import _$ from 'js/api/getdata'
import qs from 'qs'
import * as Util from 'js/util/util'
import { sendLogBuryingPointMethods } from './private-apis'
import { openUrlInside, openUrlOutside } from '@filez/js-2-native'

class DocsEdit {
  constructor(fileInfo) {
    this.data = fileInfo
  }

  /**
   * 打开窗口
   * @param {Object} openObject
   * @param {String} openObject.url
   * @param {String} openObject.client outside/inside 客户端打开方式
   */
  static openurl({ url, client }) {
    if (Util.isClient()) {
      const params = {}
      params.url = url
      if (client === 'outside') { // txt文件：客户端通过外部浏览器预览
        openUrlOutside(params)
      } else {
        params.width = '800'
        params.height = '600'
        params.fullscreen = 'false'
        openUrlInside(params)
      }
    } else {
      window.open(url)
    }
  }

  /**
   * 日志上报
   */
  reportLog() {
    const {
      path_type: pathType, nsid, neid, path,
    } = this.data
    const pathSplit = path.split('/')
    sendLogBuryingPointMethods({
      category: 0,
      action: 15,
      path_type: pathType,
      nsid,
      neid,
      entityStr1: pathSplit.pop(),
      entityStr2: pathSplit.join('/') === '' ? '/' : pathSplit.join('/'),
    })
  }

  /**
   * docs编辑
   * @return Promise
   */
  docsEdit() {
    return new Promise(((resolve, reject) => {
      const {
        path, neid, path_type: pathType, prefix_neid: prefixNeid, from, nsid,
      } = this.data
      let location = ''
      let paramobj = {}
      const lockData = {
        url: path,
        path_type: pathType,
        from,
        prefix_neid: pathType === 'share_in' || pathType === 'share_out' ? prefixNeid : null,
        time: 60,
        nsid,
      }
      location = `${window.location.protocol}//${window.location.host}/view/preview/EditByLenovoDocs.html?`
      paramobj = {
        neid,
        uid: store.getters.uId
      }
      location = `${location}${qs.stringify(paramobj)}`
      this.reportLog()
      _$.getData('docsLock', lockData).then((res) => {
        const { status } = res
        if (status === 200) {
          DocsEdit.openurl({ url: location, client: 'outside' })
          resolve()
        } else {
          const { message } = res
          reject(message)
        }
      }).catch((error) => {
        reject(error)
      })
    }))
  }
}
export default DocsEdit
